import { render, staticRenderFns } from "./medicineList.vue?vue&type=template&id=2627fa95&scoped=true&"
import script from "./medicineList.vue?vue&type=script&lang=js&"
export * from "./medicineList.vue?vue&type=script&lang=js&"
import style0 from "./medicineList.vue?vue&type=style&index=0&id=2627fa95&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2627fa95",
  null
  
)

export default component.exports